import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token') || null);
  const [fullName, setFullName] = useState(localStorage.getItem('fullName') || '');
  const [userId, setUserId] = useState(localStorage.getItem('userId') || '');
  const [username, setUsername] = useState(localStorage.getItem('username') || '');
  const [roles, setRoles] = useState(localStorage.getItem('roles') || [])
  const [roleMenus, setRoleMenus] = useState(() => {
  const stored = localStorage.getItem('roleMenus');
    return stored && stored !== 'undefined' ? JSON.parse(stored) : [];
  });

  //username habilitados para cancelar
  const allowedToCancel = [
    //'admin',
    "yohana.tapia",
    'admin',
    "ING.PEDRO",
    'contabilidad1',
    'soporte_tecnico',
    'gerencia_ventas'
  ];

   const allowedToCancelVaroExpress = [
    //'admin',
    'admin',
    "ING.PEDRO",
    'contabilidad1',
    'soporte_tecnico',
    'gerencia_ventas'
  ];

  //Permisos para habilitar adicionales en ordenes normales
   const allowedToAddaAdditional = [
    //'admin',
    'admin',
    "ING.PEDRO",
    'contabilidad1',
    "yohana.tapia",
    'soporte_tecnico',
    'gerencia_ventas',
     // 'ofici31'
     //,'contador',
  ];

  // Usuarios habilitados para modificar los costos de la orden
  const allowedToModifyCosts = [
    "admin",
    "ING.PEDRO",
    "contabilidad1",
    "soporte_tecnico",
    "gerencia_ventas",
    // 'ofici31'
  ];
  
  useEffect(() => {
    localStorage.setItem('token', token);
    localStorage.setItem('fullName', fullName);
    localStorage.setItem('userId', userId);
    localStorage.setItem('username', username);
    localStorage.setItem('roles', roles);
    localStorage.setItem('roleMenus', JSON.stringify(roleMenus));
  }, [token, fullName, userId, username, roles, roleMenus]);

  const login = (newToken, newFullName, newUserId, username, roles, newRoleMenus) => { 
    const rolesSave = JSON.stringify(roles)
    setToken(newToken);
    setFullName(newFullName);
    setUserId(newUserId);
    setUsername(username);
    setRoles(rolesSave);
    setRoleMenus(newRoleMenus);
  };

  const logout = () => {
    setToken(null);
    setFullName('');
    setUsername('');
    setUserId(null);
    setRoles([]);
    localStorage.removeItem('token');
    localStorage.removeItem('fullName');
    localStorage.removeItem('userId');
    localStorage.removeItem('username');
    localStorage.removeItem('roles');
    localStorage.removeItem('roleMenus');
  };

  const isAdmin = () => {
    let admin = false;

    if (!Array.isArray(roles)) {
      const rolesArray = JSON.parse(roles ?? "[]");
      if (rolesArray.length > 0) {
        admin = rolesArray.includes("ADMINISTRADOR");
      }
    }
    return admin;
  }

  const isAccountant = () => {
    let accountant = false;

    if (!Array.isArray(roles)) {
      const rolesArray = JSON.parse(roles);
      if (rolesArray.length > 0) {
        accountant = rolesArray.includes("CONTADOR");
      }
    }
    return accountant;
  }
  
  const isOffice = () => {
    let office = false;

    if (!Array.isArray(roles)) {
      const rolesArray = JSON.parse(roles);
      if (rolesArray.length > 0) {
        office = rolesArray.includes("OFICINA");
      }
    }
    return office;
  }

  const canCancelOrder = () => {
    return allowedToCancel.includes(username);
  };

  const canCancelVaroExpress = () => {
    return allowedToCancelVaroExpress.includes(username);
  };

  const UsersAllowedToAddaAdditional = () => {
    return allowedToAddaAdditional.includes(username);
  };

  // función para validar si puede modificar costos
  const canModifyOrderCosts = () => {
    return allowedToModifyCosts.includes(username);
  };

  return (
    <AuthContext.Provider value={{ token, fullName, userId, login, logout, username, roles, roleMenus, isAdmin, isAccountant, isOffice, canCancelOrder, canCancelVaroExpress, UsersAllowedToAddaAdditional, canModifyOrderCosts }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};